import React from "react"
import { useHistory, useParams } from "react-router"
import BreadCrumb from "components/BreadCrumb"
import { EmployeeSettingsRoutes } from "app/routes/types"
import routes from "app/routes"
import { HeaderWrapper, StyledTab, StyledTabs, StyledAppBar } from "./style"
import Config from "./config"
import { useFilterTabsByFeatureFlags, TabConfig } from "./hooks"

const EmployeeSettingsTabs = ({ id: tabId }: { id: EmployeeSettingsRoutes }) => {
  const history = useHistory()
  const { id: userId } = useParams<{ id: string }>()
  const config = useFilterTabsByFeatureFlags<TabConfig>(Config)
  const handleClick = (newTabId: EmployeeSettingsRoutes) => {
    history.push(`/employees/${userId}/${newTabId}`)
  }
  return (
    <StyledAppBar color="primary" position="sticky" elevation={0}>
      <BreadCrumb routes={routes} />
      <HeaderWrapper>
        <StyledTabs value={tabId} TabIndicatorProps={{ className: "indicator" }}>
          {config.map(({ id, label }) => (
            <StyledTab key={id} label={label} value={id} selected={tabId === id} onClick={() => handleClick(id)} />
          ))}
        </StyledTabs>
      </HeaderWrapper>
    </StyledAppBar>
  )
}

export default EmployeeSettingsTabs
